// src/components/auth/TarjetaAcceso.js
// =========================================================================
// Marco común de las pantallas sin sesión que acompañan al acceso (recuperar y
// restablecer la contraseña): mismo fondo, tarjeta y marca que el Login.
// =========================================================================
import React from 'react';
import LoginBackground from '../LoginBackground';
import { useNombreClinica } from '../../hooks/useNombreClinica';

export const estiloEntrada = 'w-full py-3.5 pl-12 pr-12 bg-[#060b14]/50 border border-white/10 rounded-2xl text-white placeholder-slate-600 text-sm font-medium focus:outline-none focus:border-sky-500/50 focus:ring-4 focus:ring-sky-500/10 transition-all shadow-inner';
export const estiloBoton = 'w-full py-4 mt-2 rounded-2xl font-black text-xs uppercase tracking-widest transition-all duration-300 bg-sky-500 text-white hover:bg-sky-400 shadow-[0_0_20px_rgba(14,165,233,0.3)] disabled:opacity-50 disabled:cursor-not-allowed';

export function Aviso({ tipo = 'error', children }) {
    const estilos = tipo === 'ok'
        ? 'text-emerald-300 bg-emerald-500/10 border-emerald-500/20'
        : 'text-red-400 bg-red-500/10 border-red-500/20';
    return (
        <div role={tipo === 'ok' ? 'status' : 'alert'} className={`p-3 mb-6 text-xs font-bold border rounded-xl text-center leading-relaxed ${estilos}`}>
            {children}
        </div>
    );
}

export default function TarjetaAcceso({ titulo, subtitulo, children }) {
    const nombreClinica = useNombreClinica();
    return (
        <LoginBackground>
            <div className="w-full max-w-[420px] px-4 mx-auto z-10">
                <div className="relative p-8 md:p-10 rounded-[2.5rem] bg-[#0a0f1c]/70 backdrop-blur-2xl border border-white/[0.05] shadow-[0_0_80px_rgba(0,0,0,0.6)] overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-white/20 to-transparent" />
                    <div className="flex flex-col items-center mb-8">
                        <img src="/brand/klyndu-icono.svg" alt="" className="w-14 h-14 mb-4" />
                        <img src="/brand/klyndu-nombre-blanco.svg" alt="Klyndu" className="h-8 w-auto mb-5" />
                        <h1 className="text-2xl font-black text-white tracking-tight text-center">{titulo}</h1>
                        {nombreClinica && (
                            <p className="text-[11px] text-slate-400 font-bold uppercase tracking-widest mt-1 text-center">{nombreClinica}</p>
                        )}
                        {subtitulo && <p className="mt-4 text-sm text-slate-400 font-medium text-center leading-relaxed">{subtitulo}</p>}
                    </div>
                    {children}
                </div>
            </div>
        </LoginBackground>
    );
}
